"use strict";

var _interopRequireDefault = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.add = add;
exports.del = del;
exports.download = download;
exports.info = info;
exports.list = list;
exports.sendLink = sendLink;
exports.update = update;
var _request = _interopRequireDefault(require("@/utils/request"));
function list(data) {
  return (0, _request.default)({
    url: '/promoter/list',
    method: 'get',
    params: data
  });
}
function add(data) {
  return (0, _request.default)({
    url: '/promoter/add',
    method: 'post',
    data: data
  });
}
function del(data) {
  return (0, _request.default)({
    url: '/promoter/delete',
    method: 'post',
    data: data
  });
}
function info(params) {
  return (0, _request.default)({
    url: '/promoter/detail',
    method: 'get',
    params: params
  });
}
function update(data) {
  return (0, _request.default)({
    url: '/promoter/edit',
    method: 'post',
    data: data
  });
}
function download(data) {
  return (0, _request.default)({
    url: '/promoter/export',
    method: 'post',
    data: data
  });
}
function sendLink(data) {
  return (0, _request.default)({
    url: '/promoter/sendLink',
    method: 'post',
    data: data
  });
}